import React from 'react';

import './styles.scss';
import {Logo} from '../helpers/Logo';
import AccountDisplay from './components/AccountDisplay';

export default ({children}) => {
  return (
    <div className="onboarding-layout">
      <div className="onboarding-layout__header">
        <Logo text="console" />
        <AccountDisplay />
      </div>
      <div className="onboarding-layout__content">
        {children}
      </div>
    </div>
  )
}
